// Global
import React from 'react';
import clsx from 'clsx';

// Local
import { HeroProps } from '../Hero';
import styles from './HeroAlternate.module.scss';
import { HeroDetailCard } from '../HeroDetailCard/HeroDetailCard';
import { ActionToolbar } from 'components/helpers/ActionToolbar';

export const HeroAlternate = (props: HeroProps) => {
  let positionClass = styles['hero-card-left'];
  const positions = props.contentPosition?.split(' ') || [];

  if (positions.includes('hero-card-right')) {
    positionClass = styles['hero-card-right'];
  }

  return (
    <div className={styles.heroAlternateBackgroundStyle}>
      <div
        className={clsx(
          styles.heroAlternate,
          positionClass,
          props?.externalPageImage ? styles.heroAlternateWithExternalImage : ''
        )}
      >
        <div className={styles.contentWrapper}>
          <div className={styles.alternateImageContainerCard}>{props?.contentPageImage}</div>
          <div className={styles.heroAlternateContentWrapperCard}>
            <HeroDetailCard {...props} contentAlignment="left" />
            {!props.disableHeroActionToolbar && (
              <div
                className={clsx(
                  styles.actionToolBarContainer,
                  props.isArticlePage && styles.articlePageAlignment
                )}
              >
                <ActionToolbar
                  actions={props.heroActionToolbarButtons}
                  toolbarIdentifier={props.heroActionToolbarIdentifier}
                  variant="horizontal"
                  className={!props.isArticlePage ? styles.centerAlignActionToolbar : undefined}
                />
              </div>
            )}
          </div>
        </div>
        {props?.externalPageImage && (
          <div className={clsx(styles.heroAlternateExternalImageWrapper)}>
            {props?.editingHelpText}
            {props?.externalPageImage}
          </div>
        )}
      </div>
    </div>
  );
};
